
export default {
    vi: {
        header: 'Đăng nhập bằng Google',
        description: 'Đăng nhập bằng tài khoản Google của bạn',
        login: 'Quay lại đăng nhập',
        register: 'Đăng ký',
    },
    en: {
        header: 'Login with Google',
        description: 'Login with your Google account',
        login: 'Back to login',
        register: 'Register',
    }
}
